<template>
  <div class="w-full">
    <OrderPricingShimmer
      v-if="isRefetching"
      :placeholder-entries-count="entriesCount"
    />
    <PriceDetails
      v-else-if="pricingDetails"
      source-page="payment"
      :bill-id="billId"
      :ticket-price="pricingDetails.ticketPrice"
      :baggage-price="pricingDetails.baggagePrice"
      :products-package="productsPackage"
      :separate-products="separateProducts"
      :seat-map-price="pricingDetails.seatMapPrice"
      :promocode-price="promocodePrice"
      :loyalty-cashback-amount="loyaltyCashbackAmount"
      :roaming-price="pricingDetails.roamingPrice"
      :medical-insurance-price="pricingDetails.medicalInsurancePrice"
      :total-price="totalPrice"
    />
  </div>
</template>

<script setup lang="ts">
  import { onMounted } from 'vue';
  import { useRoute } from 'vue-router';

  import { PriceDetails } from '@/entities/price-details';

  import { useOrderPricing } from '../model';
  import OrderPricingShimmer from './OrderPricingShimmer.vue';

  const props = defineProps<{ orderId: string; billId: string }>();
  const emit = defineEmits<{ onPriceChange: [newPrice: string] }>();
  const route = useRoute();

  const {
    isRefetching,
    pricingDetails,
    productsPackage,
    separateProducts,
    promocodePrice,
    loyaltyCashbackAmount,
    totalPrice,
    entriesCount,
  } = useOrderPricing(props.orderId, props.billId);

  onMounted(() => {
    if (route.query.showPriceChangeToast === 'true') {
      emit('onPriceChange', totalPrice.value?.toString() || '');
    }
  });
</script>
